export type EasingTypeStr =
  | 'linear'
  | 'quadIn'
  | 'quadOut'
  | 'quadInOut'
  | 'quadInOut'
  | 'cubicIn'
  | 'cubicOut'
  | 'cubicInOut'
  | 'quartIn'
  | 'quartOut'
  | 'quartInOut'
  | 'quintIn'
  | 'quintOut'
  | 'quintInOut'
  | 'backIn'
  | 'backOut'
  | 'backInOut'
  | 'circIn'
  | 'circOut'
  | 'circInOut'
  | 'bounceOut'
  | 'bounceIn'
  | 'bounceInOut'
  | 'elasticIn'
  | 'elasticOut'
  | 'elasticInOut'
  | 'sineIn'
  | 'sineOut'
  | 'sineInOut'
  | 'expoIn'
  | 'expoOut'
  | 'expoInOut'
  // @since 0.21.0
  | 'easeInOutQuad'
  | 'easeOutElastic'
  | 'easeInOutElastic'
  | '';
export type EasingTypeFunc = (t: number) => number;

export type EasingType = EasingTypeStr | EasingTypeFunc;
